import React, { useState } from 'react';
import Axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate } from 'react-router-dom';
import './forgetpassword.css';
import ppp from '../landing/Images/Forgetpassword.webp';
 
const ForgetPassword = () => {
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showOTPInput, setShowOTPInput] = useState(false);
  const [showPasswordFields, setShowPasswordFields] = useState(false);
  const [buttonText, setButtonText] = useState('Send OTP');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
 
  const validateEmail = (email) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  };
 
  const handleSendOtp = async () => {
    if (!email) {
      toast.error('Email is required');
      return;
    }
    if (!validateEmail(email)) {
      toast.error('Please enter a valid email address.');
      return;
    }
    setIsLoading(true);
    try {
      const response = await Axios.post(
        'https://api.litaxfilers.com/forgetsendOTP',
        { email }
      );
      if (response.data.success) {
        setShowOTPInput(true);
        setButtonText('Verify OTP');
      } else {
        toast.error('Failed to send OTP. Please try again.');
      }
    } catch (error) {
      toast.error('An error occurred while sending OTP.');
    } finally {
      setIsLoading(false);
    }
  };
 
  const handleVerifyOtp = async () => {
    try {
      const response = await Axios.post(
        'https://api.litaxfilers.com/forgetverifyOTP',
        { email, otp }
      );
      if (response.data.success) {
        setShowPasswordFields(true);
        setShowOTPInput(false);
        setButtonText('Reset Password');
      } else {
        toast.error('OTP not matched. Please try again.');
      }
    } catch (error) {
      toast.error('Error verifying OTP. Please try again.');
    }
  };
 
  const handleResetPassword = async () => {
    if (newPassword !== confirmPassword) {
      toast.error('New Password and Confirm Password do not match.');
      return;
    }
    setIsLoading(true);
    try {
      const response = await Axios.post(
        'https://api.litaxfilers.com/forgetPassword',
        { email, newPassword }
      );
      if (response.data.success) {
        toast.success('Password updated successfully!');
        navigate('/login');
      } else {
        toast.error('Error updating password. Please try again.');
      }
    } catch (error) {
      toast.error('Error updating password. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };
 
  return (
    <div className="fp-otp-container">
      <div className="fp-otp-box">
        <div className="fp-otp-image">
          <img src={ppp} alt="Reset Password" className="fp-otp-img" />
        </div>
        <div className="fp-otp-content">
          <h1 className="fp-otp-title">Forgot Password</h1>
          <form
            className="fp-otp-form"
            onSubmit={(e) => e.preventDefault()}
          >
            {!showPasswordFields && (
              <>
                <label className="fp-otp-label">Email</label>
                <input
                  type="email"
                  placeholder="Enter your email address"
                  className="fp-otp-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={showOTPInput}
                />
                {showOTPInput && (
                  <>
                    <label className="fp-otp-label">OTP</label>
                    <input
                      type="text"
                      placeholder="Enter OTP"
                      className="fp-otp-input"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                    />
                  </>
                )}
              </>
            )}
            {showPasswordFields && (
              <>
                <label className="fp-otp-label">New Password</label>
                <input
                  type="password"
                  placeholder="New Password"
                  className="fp-otp-input"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
                <label className="fp-otp-label">Confirm Password</label>
                <input
                  type="password"
                  placeholder="Confirm Password"
                  className="fp-otp-input"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </>
            )}
            <button
              type="button"
              className="fp-otp-button"
              onClick={
                showPasswordFields
                  ? handleResetPassword
                  : showOTPInput
                  ? handleVerifyOtp
                  : handleSendOtp
              }
              disabled={isLoading}
            >
              {isLoading ? 'Processing...' : buttonText}
            </button>
          </form>
          <p className="fp-otp-footer">
            Remembered your password?{' '}
            <Link to="/login" className="fp-otp-link">
              Login here
            </Link>
          </p>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};
 
export default ForgetPassword;
 